import { Component, Input, OnInit, SecurityContext, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services';
import { OccurrenceService } from 'src/app/services/occurrence.service';
import { RbacService } from 'src/app/services/rbac.service';
import { ToastService } from 'src/app/services/toast.service';
import { SignalingTypeEnum, UserDutyEnum } from 'src/enumerators';
import { DeviceSignalingOccurrence, HorizontalSignalingOccurrence, VerticalSignalingOccurrence } from 'src/models';

@Component({
  selector: 'app-occurrence-creation-modal',
  templateUrl: './occurrence-creation-modal.component.html',
  styleUrls: ['./occurrence-creation-modal.component.css']
})
export class OccurrenceCreationModalComponent {
  @ViewChild('occurrenceCreation') occTemplate: TemplateRef<any>;
  signaling: any; //Sinalização de referência da ocorrência
  modalRef: BsModalRef;
  occurrence: any;

  constructor(
    private _modalService: BsModalService,
    private _sanitizer: DomSanitizer,
    private _occurrenceService: OccurrenceService,
    private _toastService: ToastService,
    private _authService: AuthService,
    private _rbac: RbacService
  ) { }

  openModal(sign) {
    if (!this._rbac.can('occurrences', 'create')) {
      this._toastService.showInfo('O usuário logado não tem permissão para realizar essa ação.')
      return;
    }

    if(sign.locations?.length) {
      sign['lat'] = sign.locations[0].lat;
      sign['lng'] = sign.locations[0].lng;
    }

    this.signaling = sign;

    if(!this.signaling.contract?.name) this.signaling.contract.name = 'Sem vínculo';

    this.setOccurrenceType(sign.type);
    this.modalRef = this._modalService.show(this.occTemplate, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: 'static',
    });
  }

  //FIXME: Alterar tipos quando classes forem criadas (APENAS PARA TESTE)
  setOccurrenceType(type: SignalingTypeEnum) {
    switch (type) {
      case SignalingTypeEnum.Device:
        this.occurrence = new DeviceSignalingOccurrence({ deviceSignalingId: this.signaling.id });
        break;
      case SignalingTypeEnum.Vertical:
        this.occurrence = new VerticalSignalingOccurrence({ verticalSignalingId: this.signaling.verticalSignalingId });
        break;
      case SignalingTypeEnum.Horizontal:
        this.occurrence = new HorizontalSignalingOccurrence({ horizontalSignalingId: this.signaling.id });
        break;
    }
  }

  closeModal() {
    this.modalRef.hide();
  }

  addFile(files: FileList) {
    const reader = new FileReader();

    reader.onload = async (img) => {
      const type = files[0].type;
      const url = URL.createObjectURL(files[0]);
      let fileValidation: boolean =  true;

      if(type.includes('video'))
        fileValidation = await this._occurrenceService.videoValidation(files[0]);

      if(!fileValidation)
        return;

      this.occurrence.files.push({ url, type, file: files[0] });
    }
    reader.readAsDataURL(files[0]);
  }

  openFile(url) {
    if (typeof url != "string") {
      url = this._sanitizer.sanitize(SecurityContext.URL, url);
    }
    window.open(url, '_blank');
  }

  removeFile(index: number) {
    this.occurrence.files.splice(index, 1);
  }

  createOccurrence() {
    this.occurrence.files = this.occurrence.files.map(file => file.file);
    switch (this.signaling.type) {
      case SignalingTypeEnum.Device:
        this._occurrenceService.createDeviceOccurrence(this.occurrence).subscribe(
          occ => {
            this._occurrenceService.uploadDeviceFiles(this.occurrence.files, occ.id).subscribe(
              () => this.closeModal(),
              () => this._toastService.showError('Houve um erro ao anexar os arquivos da ocorrência.')
            );

            this._toastService.showSuccess('Ocorrência do dispositivo foi criada com sucesso.');
          },
          error => this._toastService.showError('Houve um erro ao criar a Ocorrência do dispositivo.')
        );
        break;
      case SignalingTypeEnum.Vertical:
        this._occurrenceService.createVerticalOccurrence(this.occurrence).subscribe(
          occ => {
            this._occurrenceService.uploadVerticalFiles(this.occurrence.files, occ.id).subscribe(
              () => this.closeModal(),
              () => this._toastService.showError('Houve um erro ao anexar os arquivos da ocorrência.')
            );

            this._toastService.showSuccess('Ocorrência do sinalização foi criada com sucesso.');
          },
          error => this._toastService.showError('Houve um erro ao criar a Ocorrência do sinalização.')
        );
        break;
      case SignalingTypeEnum.Horizontal:
        this._occurrenceService.createHorizontalOccurrence(this.occurrence).subscribe(
          occ => {
            this._occurrenceService.uploadHorizontalFiles(this.occurrence.files, occ.id).subscribe(
              () => this.closeModal(),
              () => this._toastService.showError('Houve um erro ao anexar os arquivos da ocorrência.')
            );

            this._toastService.showSuccess('Ocorrência do sinalização foi criada com sucesso.');
          },
          error => this._toastService.showError('Houve um erro ao criar a Ocorrência da sinalização.')
        );
        break;
    }
  }
}
